import React, { useEffect, useRef } from 'react';
import './Connect.scss';
import gsap from 'gsap';
import SEO from '../../components/SEO/SEO';

const Connect = props => {
  const icons = useRef(null);
  const copyrightRef = useRef(null);

  useEffect(() => {
    if (!icons.current || !copyrightRef.current) return;

    const tl = gsap.timeline({
      onComplete: () => {
        icons.current?.classList.add('hover-icons');
      },
      onStart: () => {
        icons.current?.classList.remove('hover-icons');
      },
    });

    tl.fromTo(
      [...icons.current.children],
      {
        opacity: 0,
        scale: 0,
      },
      {
        delay: 0.5,
        opacity: 1,
        scale: 1,
        ease: 'back',
        stagger: 0.1,
      }
    );

    tl.fromTo(
      [copyrightRef.current],
      {
        opacity: 0,
        scale: 0,
      },
      {
        delay: 0,
        opacity: 1,
        scale: 1,
        translateX: '-50%',
        ease: 'back',
        stagger: 0.1,
      }
    );
  }, [icons, copyrightRef]);

  return (
    <>
      <SEO
        title="Connect with Me - Moid Hasan Beig | Contact & Social Links"
        description="Get in touch with Moid Hasan Beig. Connect via LinkedIn, GitHub, email, or Strava. Based in Montreal, Canada. Let's chat about tech, design, or just say hi!"
        keywords="Moid Hasan Beig, contact, LinkedIn, GitHub, email, Montreal developer, software developer contact"
        path="/connect"
      />
      <div className="connect-page">
        <div className="connect-page-content">
          <h1>Connect with me</h1>
          <div ref={icons} className="my-flex icons-container">
            <a
              className="icon-container"
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/in/moidhasanbeig/"
            >
              <div className="connect-icon linkedin-icon link" />
            </a>
            <a
              className="icon-container"
              target="_blank"
              rel="noreferrer"
              href="https://github.com/MoidHasanBeig"
            >
              <div className="connect-icon github-icon link" />
            </a>
            <a
              className="icon-container"
              target="_blank"
              rel="noreferrer"
              href="mailto:moid.dev@outlook.com"
            >
              <div className="connect-icon mail-icon link" />
            </a>
            <a
              className="icon-container"
              target="_blank"
              rel="noreferrer"
              href="https://strava.app.link/93bqSHiTwZb"
            >
              <div className="connect-icon strava-icon link" />
            </a>
          </div>
        </div>
        <div className="copyright-text" ref={copyrightRef}>
          moid.dev&copy;{new Date().getFullYear()}
        </div>
      </div>
    </>
  );
};

export default Connect;
